import { LyneContextHelp } from "components/Lyne/LyneContextHelp";
import { getResource, ResourceKey, useTranslations } from "providers";

interface FormContextHelpProps {
  title: ResourceKey;
  content: ResourceKey;
}

export const FormContextHelp: React.FC<FormContextHelpProps> = ({ title, content }) => {
  const i18n = useTranslations();
  const titleToUse = title ? getResource(title) : i18n.Help;
  const contentToUse = content ? getResource(content) : i18n.ContextHelp_Fallback_Content.replace("{0}", `${title}`);

  return <LyneContextHelp title={titleToUse} content={contentToUse} />;
};
